import React from 'react'
import format from 'date-fns/esm/format'

import EnhancedLazyLoad from '../../../../shared/components/enhancedLazyLoad'
import ui from '../../../../../common/constants/ui'

const SearchPageRelatedPost = ({ post }) => {
  const publishDate = format(post.date, 'dd MMM yyyy')

  return (
    <li className="search-related-posts__post">
      <article className="search-related-posts__post-container">
        <header className="search-related-posts__post-header">
          <a
            className="search-related-posts__post-preview-link is-hidden-phone"
            href={post.url}
          >
            <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
              <img
                alt={post.title}
                className="search-related-posts__post-image"
                src={post.image}
              />
            </EnhancedLazyLoad>
          </a>
          <a
            className="search-related-posts__post-preview-title-link"
            href={post.url}
          >
            <h2 className="fds-c-text-heading -size-xs -color-mid">
              {post.title}
            </h2>
          </a>
        </header>
        <div className="search-related-posts__post-teaser">
          <p className="fds-c-text-body -size-s -color-mid">{post.summary}</p>
        </div>
        <footer className="search-related-posts__post-footer">
          <div className="fds-c-text-body -size-s -color-mid">
            <div className="search-related-posts__post-publication-meta">
              {post.author && (
                <EnhancedLazyLoad height="100%" once offset={ui.lazyLoadOffset}>
                  <img
                    className="search-related-posts__post-author_photo"
                    alt={post.author}
                    src={post.author_avatar}
                  />
                </EnhancedLazyLoad>
              )}
              <div className="search-related-posts__post-details">
                <address className="search-related-posts__post-author">
                  <p className="search-related-posts__post-author-link">
                    {post.author && (
                      <a
                        className="fds-c-text-link -decoration-reversed -color-inherit"
                        href={post.author_url}
                      >
                        {post.author}
                      </a>
                    )}
                  </p>
                </address>
                <time dateTime={post.date} title={publishDate}>
                  {publishDate}
                </time>
              </div>
            </div>
            <div className="search-related-posts__post-primary-category">
              <a
                className="fds-c-text-link -decoration-reversed -color-inherit -weight-bold"
                href={post.category_url}
              >
                {post.category}
              </a>
            </div>
          </div>
        </footer>
      </article>
    </li>
  )
}

export default SearchPageRelatedPost
